module.exports = __webpack_public_path__ + "img/jimny-glx-negro.219f7137.png";